module.exports = __webpack_public_path__ + "img/bindCard_pb.5bbb0ece.jpg";